import { defineMessages } from 'react-intl'

export default defineMessages({
    title: {
        id: 'components.AvailabilityDataTable.components.BookingRejectModal.title',
        defaultMessage: 'Reject booking',
    },
    rejectMessageLabel: {
        id: 'components.AvailabilityDataTable.components.BookingRejectModal.rejectMessageLabel',
        defaultMessage: 'Please let us know the reason for rejection:',
    },
    rejectMessagePlaceholder: {
        id: 'components.AvailabilityDataTable.components.BookingRejectModal.rejectMessagePlaceholder',
        defaultMessage: 'Rejection reason',
    },
    rejectButton: {
        id: 'components.AvailabilityDataTable.components.BookingRejectModal.rejectButton',
        defaultMessage: 'Reject',
    },
})
